import { styled } from "@ff/ui";
import Text from "@ff/ui/Text";

const TextEllipsis = styled(Text)<{ lineClamp?: string }>(({ lineClamp = '5' }) => ({
  display: '-webkit-box',
  overflow: 'hidden',
  '-webkit-line-clamp': lineClamp,
  '-webkit-box-orient': 'vertical'
}));

export default TextEllipsis;
